<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="PT" id="pt1"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="ePub-B">Correspondence with Commentary</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?d2c93048